import React, { useState } from 'react';
import { DeleteOutlined, PlusOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Select, message, AutoComplete } from 'antd';

const EmploymentInfo = ({ employmentData, setEmploymentData, selectors, setChangedData, allowedEdit }) => {

  const [showEmploymentModal, setShowEmploymentModal] = useState(false);
  const [editEmployment, setEditEmployment] = useState(false);
  const [editEmploymentIndex, setEditEmploymentIndex] = useState(0);
  const [newEmploymentData, setNewEmploymentData] = useState({
      EmploymentDate: '',
      DismissalDate: '',
      Organization: '',
      Departament: '',
      Position: '',
      Address: '',
      Duties: '',
      ActivityProfile: '',
      Country: {
        Name: '',
        UID: ''
      },
      City: '',
      EmploymentType: {
				Name: '',
				UID: ''
			},
			RowKey: '',
      InGroupActivity: false
  });

  const updateChangedData = (key, data) => {
    setChangedData(prevState => ({
        ...prevState,
        [key]: data
    }));
  };

  const handleEmploymentChange = (e, option) => {
      let { name, value, dataset } = typeof e === "string" ? option : e.target;
      const { parent } = dataset;
      if(name === 'EmploymentDate' || name === 'DismissalDate') value += 'T00:00:00';
      if (parent) {
        if(dataset.uid) {
          setNewEmploymentData(prevState => ({
              ...prevState,
              [parent]: {
                  ...prevState[parent],
                  [name]: value,
                  UID: dataset.uid
              }
          }));
        } else {
          setNewEmploymentData(prevState => ({
              ...prevState,
              [parent]: {
                  ...prevState[parent],
                  [name]: value
              }
          }));
        }
      } else {
          setNewEmploymentData(prevState => ({
              ...prevState,
              [name]: value
          }));
      }
  };

  const handleEmploymentCountryChange = (value) => {
    let parent = 'Country';
    setNewEmploymentData(prevState => ({
        ...prevState,
        [parent]: {
            ...prevState[parent],
            Name: value,
            UID: ''
        }
    }));
  }

  const handleAddEmploymentRow = (e) => {
      e.preventDefault();
      if (Date.parse(newEmploymentData.EmploymentDate) > Date.parse(newEmploymentData.DismissalDate)) {
        message.warning('Дата трудоустройства не может быть больше даты увольнения!');
      } else if (Date.parse(newEmploymentData.EmploymentDate) > Date.now()) {
        message.warning('Дата трудоустройства не может быть больше текущей даты!');
      } else if (newEmploymentData.Organization.length === 0) {
        message.warning('Введите наименование предприятия/компании!');
      } else if (newEmploymentData.Position.length === 0) {
        message.warning('Введите должность по месту работы!');
      } else if (newEmploymentData.EmploymentDate.length === 0 || newEmploymentData.DismissalDate.length === 0) {
        message.warning('Заполните период трудовой деятельности!');
      } else {
        if (editEmployment) {
            setEmploymentData(prevData => {
                const newData = [...prevData];
                newData[editEmploymentIndex] = newEmploymentData;
                // updateChangedData('LaborActivity', newData); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все места работы
                return newData;
            });
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              if (!updatedChangedData.hasOwnProperty('LaborActivity')) {
                  updatedChangedData.LaborActivity = [newEmploymentData];
              } else {
                  if (newEmploymentData.RowKey === "") {
                      const index = updatedChangedData.LaborActivity.findIndex(emp => emp.id === newEmploymentData.id);
                      if (index !== -1) {
                          updatedChangedData.LaborActivity[index] = newEmploymentData;
                      } else {
                          updatedChangedData.LaborActivity.push(newEmploymentData);
                      }
                  } else {
                      const index = updatedChangedData.LaborActivity.findIndex(emp => emp.RowKey === newEmploymentData.RowKey);
                      if (index !== -1) {
                          updatedChangedData.LaborActivity[index] = newEmploymentData;
                      } else {
                          updatedChangedData.LaborActivity.push(newEmploymentData);
                      }
                  }
              }
            
              return updatedChangedData;
            });
        } else {
            newEmploymentData.Deletable = true;
            newEmploymentData.id = Date.now();
            setEmploymentData(prevData => {
                if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                  // updateChangedData('LaborActivity', [newEmploymentData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все места работы
                  return [newEmploymentData];
                } else {
                  // updateChangedData('LaborActivity', [...prevData, newEmploymentData]); Раскомментировать и закомментировать setChangedData снизу, если надо передавать все места работы
                  return [...prevData, newEmploymentData];
                }
            });
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              if (!updatedChangedData.hasOwnProperty('LaborActivity')) {
                  updatedChangedData.LaborActivity = [newEmploymentData];
              } else {
                  updatedChangedData.LaborActivity.push(newEmploymentData);
              }            
              return updatedChangedData;
            });
        }
        setShowEmploymentModal(false);
        setNewEmploymentData({
          EmploymentDate: '',
          DismissalDate: '',
          Organization: '',
          Departament: '',
          Position: '',
          Address: '',
          Duties: '',
          ActivityProfile: '',
          Country: {
            Name: '',
            UID: ''
          },
          City: '',
          EmploymentType: {
            Name: '',
            UID: ''
          },
          RowKey: '',
          InGroupActivity: false
        });
        setEditEmployment(false);
        setEditEmploymentIndex(-1);
      }
  };
  
  const handleCloseEmploymentModal = () => {
      setShowEmploymentModal(false);
      setNewEmploymentData({
        EmploymentDate: '',
        DismissalDate: '',
        Organization: '',
        Departament: '',
        Position: '',
        Address: '',
        Duties: '',
        ActivityProfile: '',
        Country: {
          Name: '',
          UID: ''
        },
        City: '',
        EmploymentType: {
          Name: '',
          UID: ''
        },
        RowKey: ''
      });
      setEditEmployment(false);
      setEditEmploymentIndex(-1);
  };

  const handleRemoveEmploymentRow = (index) => {
      setEmploymentData(prevData => {
          const newData = [...prevData];
          if(newData[index].RowKey.length > 0) {
            newData[index].delete = true;
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              if (!updatedChangedData.hasOwnProperty('LaborActivity')) {
                  updatedChangedData.LaborActivity = [newData[index]];
              } else {
                  const i = updatedChangedData.LaborActivity.findIndex(emp => emp.RowKey === newData[index].RowKey);
                  if (i !== -1) {
                      updatedChangedData.LaborActivity[i].delete = true;
                  } else {
                      updatedChangedData.LaborActivity.push(newData[index]);
                  }
              }            
              return updatedChangedData;
            });
          }
          else {
            setChangedData(prevState => {
              const updatedChangedData = { ...prevState };
              const i = updatedChangedData.LaborActivity.findIndex(emp => emp.id === newData[index].id);
              if (i !== -1) {
                  updatedChangedData.LaborActivity.splice(i, 1);
              }                
              return updatedChangedData;
            });
            newData.splice(index, 1);
          }
          // updateChangedData('LaborActivity', newData);
          return newData;
      });
  };

  const isObjectEmpty = (data) => {
      for (const item of data) {
          for (const key in item) {
              if (typeof item[key] === 'object') {
                  const subItem = item[key];
                  for (const subKey in subItem) {
                      if (subItem[subKey] !== '') {
                          return false;
                      }
                  }
              } else if (item[key] !== '') {
                  return false;
              }
          }
      }
      return true;
  };

  const formatDate = (date) => {
      const rawDate = date.split('T')[0];
      const dateParts = rawDate.split('-');
      return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
  }

  return (
    <>
      <div className='profile-content'>
        { allowedEdit && <button type='button' className='addButton' onClick={() => setShowEmploymentModal(true)}><PlusOutlined /> Добавить место работы</button>}
        {!isObjectEmpty(employmentData) && employmentData.map((emp, index) => emp.delete !== true &&  (
            <div className={'itemCard'} style={{ height: '90px' }}>
              <h1>{emp.Position ? emp.Position : 'Не указано'}</h1>
              <p>{emp.Organization ? emp.Organization : 'Не указано'}</p>
              <p>С {formatDate(emp.EmploymentDate)} по {emp.DismissalDate === '3999-12-31T00:00:00' ? '' : formatDate(emp.DismissalDate)}</p>
              {emp.InGroupActivity === false && allowedEdit && (
                <div className={'actions'}>
                    <button className="btn" onClick={() => {
                          setNewEmploymentData(emp);
                          setEditEmployment(true);
                          setEditEmploymentIndex(index);
                          setShowEmploymentModal(true);
                      }}><EditOutlined /></button>
                      <button className="btn" onClick={() => handleRemoveEmploymentRow(index)}><DeleteOutlined /></button>
                </div>                
              )}
            </div>
        ))}
        {showEmploymentModal && (
          <>
              <div className="modal-bg" onClick={() => handleCloseEmploymentModal()}></div>
              <div className="modal">
                  <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Место работы</h4>
                  <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseEmploymentModal()} ><CloseOutlined /></button>
                  <table>
                    <tbody>
                      <tr>
                        <td width="25%"><p>Наименование предприятия/компании:</p></td>
                        <td width="75%" style={{ position: 'relative' }}>
                          <input type="text" name="Organization" value={newEmploymentData.Organization} onChange={handleEmploymentChange} />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Профиль деятельности предприятия/компании:</p></td>
                        <td><input type="text" name="ActivityProfile" value={newEmploymentData.ActivityProfile} onChange={handleEmploymentChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Подразделение:</p></td>
                        <td><input type="text" name="Departament" value={newEmploymentData.Departament} onChange={handleEmploymentChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Период трудовой деятельности:</p></td>
                        <td>
                          С <input type="date" name="EmploymentDate" value={newEmploymentData.EmploymentDate ? newEmploymentData.EmploymentDate.split('T')[0] : ''} onChange={handleEmploymentChange} />
                          по <input type="date" name="DismissalDate" value={newEmploymentData.DismissalDate ? newEmploymentData.DismissalDate.split('T')[0] : ''} onChange={handleEmploymentChange} />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Должность:</p></td>
                        <td><input type="text" name="Position" value={newEmploymentData.Position} onChange={handleEmploymentChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Функциональные обязанности:</p></td>
                        <td><input type="text" name="Duties" value={newEmploymentData.Duties} onChange={handleEmploymentChange} /></td>
                      </tr>
                      <tr>
                        <td><p>Вид занятости:</p></td>
                        <td>
                          <Select
                            size='small'
                            value={newEmploymentData.EmploymentType.Name ? newEmploymentData.EmploymentType.Name : undefined}
                            onChange={handleEmploymentChange}
                            placeholder="Выберите вид занятости"
                            style={{ width: '100%' }}
                            options={selectors.employmentTypes}
                          />
                        </td>
                      </tr>            
                      <tr>
                        <td><p>Страна:</p></td>
                        <td>
                          {/* <Select
                            size='small'
                            value={newEmploymentData.Country.Name ? newEmploymentData.Country.Name : undefined}
                            onChange={handleEmploymentChange}
                            showSearch
                            style={{ width: '100%' }}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                            placeholder="Выберите страну"
                            notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                            options={selectors.employmentCountries}
                          /> */}
                          <AutoComplete
                            allowClear={true}
                            size='medium'
                            options={selectors.employmentCountries}
                            style={{
                                width: '100%',
                            }}
                            value={newEmploymentData.Country.Name}
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                            onSelect={(e, option) => handleEmploymentChange(e, option)}
                            onChange={handleEmploymentCountryChange}
                            placeholder="Выберите страну"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td><p>Город:</p></td>
                        <td>
                          {/* <select name="City" value={newEmploymentData.City} onChange={handleEmploymentChange}>
                            <option value="" disabled="true">Город</option>
                            <option value="Нукус">Нукус</option>
                            <option value="Ташкент">Ташкент</option>
                            <option value="Москва">Москва</option>
                            <option value="Пекин">Пекин</option>
                          </select> */}
                          <input type="text" name="City" value={newEmploymentData.City} onChange={handleEmploymentChange} />
                        </td>
                      </tr>            
                      <tr>
                        <td><p>Адрес организации:</p></td>
                        <td><input type="text" name="Address" value={newEmploymentData.Address} onChange={handleEmploymentChange} /></td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ marginTop: "32px" }}></div>
                  <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={handleAddEmploymentRow}>ОК</button>
              </div>
          </>
        )}
      </div>
    </>
  );
};

export default EmploymentInfo;
